/** Upload endpoint calls — presign (get S3 URL) and confirm (get public URL after PUT). */
import type { AllowedMimeType } from '@olimhub/shared'
import { apiClient } from '../client'

export interface PresignResponse {
  uploadUrl: string
  key: string
}

export interface ConfirmResponse {
  publicUrl: string
}

export const uploadApi = {
  presign: (mimeType: AllowedMimeType, fileSize: number) =>
    apiClient
      .post<PresignResponse>('/upload/presign', { mimeType, fileSize })
      .then((r) => r.data),

  confirm: (key: string) =>
    apiClient.post<ConfirmResponse>('/upload/confirm', { key }).then((r) => r.data),
}
